import { Auth } from "aws-amplify"
import { getInvestorWithoutWrapper } from "./ApiHooks"


export const signOut = async () => {
    await Auth.signOut()
    window.location.reload()
}

export enum AuthState {
    FullAccess = "FullAccess",
    OnboardingAccess = "OnboardingMissing",
    NoAccess = "NoAccess"
}


export const getAuthState = async (): Promise<AuthState> => {
    try {
        const investor = await getInvestorWithoutWrapper()
        if (investor && investor.onboardingCompleted) return AuthState.FullAccess
        else return AuthState.OnboardingAccess
    } catch (error) {
        
    }
    return AuthState.NoAccess
}